import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { indicatorRequest } from './actions'
import { selectIndicator } from './selectors'

export function useIndicatorStore(type, value) {
  const dispatch = useDispatch()
  const key = `${type}${value === undefined ? '' : `-${value}`}`.toLowerCase()
  const indicator = useSelector(store => selectIndicator(store, { key }))

  useEffect(() => {
    if (type && indicator === undefined) {
      dispatch(indicatorRequest({ key, type, value }))
    }
  }, [indicator, dispatch, type, value, key])

  return {
    indicator: indicator?.data,
    error: indicator?.error
  }
}
